import React from "react";
import MoneyOutlinedIcon from "@mui/icons-material/MoneyOutlined";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import PointOfSale from "@mui/icons-material/PointOfSale";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";

export default function PaymentMethodIcon(props) {
  const { paymentType } = props;

  if (paymentType === "offline") {
    return <MoneyOutlinedIcon sx={{ color: "#777" }} />;
  } else if (paymentType === "moto") {
    return <LocalPhoneIcon sx={{ color: "#777" }} />;
  } else if (paymentType === "card_present") {
    return <PointOfSale sx={{ color: "#777" }} />;
  } else if (paymentType === "card") {
    return <CreditCardOutlinedIcon sx={{ color: "#777" }} />;
  } else {
    return "";
  }
}
